import { render } from "./ViewRequestDetails.vue?vue&type=template&id=b7dbf4f4&scoped=true"
import script from "./ViewRequestDetails.vue?vue&type=script&lang=js"
export * from "./ViewRequestDetails.vue?vue&type=script&lang=js"

import "./ViewRequestDetails.vue?vue&type=style&index=0&id=b7dbf4f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7dbf4f4"]])

export default __exports__